import React from "react";
import { ShieldCheck, Lock } from "lucide-react";

export default function SiteSeguroBadge() {
  return (
    <div
      data-testid="site-seguro-badge"
      className="fixed bottom-6 left-6 z-40 select-none"
      aria-label="Site seguro com SSL/TLS ativo"
    >
      <div className="inline-flex items-center gap-2.5 bg-[#16a34a] text-white px-3.5 py-2.5 shadow-lg">
        <ShieldCheck size={22} strokeWidth={2.2} />
        <div className="leading-tight">
          <div className="text-[11px] font-bold uppercase tracking-widest">Site Seguro</div>
          <div className="text-[10px] flex items-center gap-1 text-white/90">
            <Lock size={10} /> SSL/TLS Ativo
          </div>
        </div>
      </div>
    </div>
  );
}
